import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { Idea } from 'common/api/endpoints/idea';

export { defaultState } from 'common/reducers/queryReducerFactory';

export type QueryParams = {
  ideaID: string;
};

const ideasActions = queryActionFactory<Idea, QueryParams>('idea', DataV2.queries.idea);

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateIdea,
  reloadQuery: reloadIdea,
  bulkRemoveAction: bulkRemoveIdeas,

  // action types
  BulkRemoveType,
  BulkLoadedType,
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
} = ideasActions;

export const upsertIdeas = (ideas: Idea[]) => {
  return ideasActions.bulkLoadedAction(
    ideas.map((idea) => {
      const queryParams = {
        ideaID: idea._id,
      };
      const queryKey = getQueryKey(queryParams);
      return {
        queryKey,
        queryParams,
        queryResponse: {
          cursor: null,
          items: [idea],
          hasNextPage: false,
        },
      };
    })
  );
};

export const removeIdeas = (ideas: Idea[]) => {
  return ideasActions.bulkRemoveAction(
    ideas.map((idea) => {
      const queryParams = {
        ideaID: idea._id,
      };
      const queryKey = getQueryKey(queryParams);
      return {
        queryKey,
        queryParams,
        items: [idea],
      };
    }),
    // We know there is only one item per query, so we can delete the query if it is empty
    true
  );
};
